var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M12.27 15.6C12.08 15.6 11.895 15.51 11.78 15.345L8.56497 10.795C8.37497 10.525 8.43997 10.15 8.70997 9.95999C8.97997 9.76999 9.35496 9.83499 9.54496 10.105L12.76 14.655C12.95 14.925 12.885 15.3 12.615 15.49C12.51 15.565 12.39 15.6 12.27 15.6Z",
    fill: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M12.7499 20.0999H12.2499C11.9199 20.0999 11.6499 19.8299 11.6499 19.4999C11.6499 19.1699 11.9199 18.8999 12.2499 18.8999H12.7499C13.0799 18.8999 13.3499 19.1699 13.3499 19.4999C13.3499 19.8299 13.0799 20.0999 12.7499 20.0999Z",
    fill: "#AFB8C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M17.7499 20.0999H14.7499C14.4199 20.0999 14.1499 19.8299 14.1499 19.4999C14.1499 19.1699 14.4199 18.8999 14.7499 18.8999H17.7499C18.0799 18.8999 18.3499 19.1699 18.3499 19.4999C18.3499 19.8299 18.0799 20.0999 17.7499 20.0999Z",
    fill: "#AFB8C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M16.2499 17.8499H12.2499C11.9199 17.8499 11.6499 17.5799 11.6499 17.2499C11.6499 16.9199 11.9199 16.6499 12.2499 16.6499H16.2499C16.5799 16.6499 16.8499 16.9199 16.8499 17.2499C16.8499 17.5799 16.5799 17.8499 16.2499 17.8499Z",
    fill: "#AFB8C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M4.2502 6.0502H3.2502C2.8102 6.0502 2.4502 5.6902 2.4502 5.2502C2.4502 4.8102 2.8102 4.4502 3.2502 4.4502H4.2502C4.6902 4.4502 5.0502 4.8102 5.0502 5.2502C5.0502 5.6902 4.6902 6.0502 4.2502 6.0502Z",
    fill: "#AFB8C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M8.2502 8.8002H3.2502C2.8102 8.8002 2.4502 8.4402 2.4502 8.0002C2.4502 7.5602 2.8102 7.2002 3.2502 7.2002H8.2502C8.6902 7.2002 9.0502 7.5602 9.0502 8.0002C9.0502 8.4402 8.6902 8.8002 8.2502 8.8002Z",
    fill: "#AFB8C1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M10.2502 6.0502H6.7502C6.3102 6.0502 5.9502 5.6902 5.9502 5.2502C5.9502 4.8102 6.3102 4.4502 6.7502 4.4502H10.2502C10.6902 4.4502 11.0502 4.8102 11.0502 5.2502C11.0502 5.6902 10.6902 6.0502 10.2502 6.0502Z",
    fill: "#AFB8C1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M3.03 9.9649C2.76 9.7699 2.385 9.8299 2.19 10.0949L0.115005 12.9449C0.0400055 13.0499 0 13.1699 0 13.2999C0 13.8799 0.745007 14.1249 1.08501 13.6549L3.16 10.8049C3.355 10.5349 3.295 10.1599 3.03 9.9649Z",
    fill: "#D0D7DE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M16.8402 14.645C16.6452 14.91 16.7002 15.285 16.9652 15.485C17.0702 15.565 17.1952 15.6 17.3202 15.6C17.5052 15.6 17.6852 15.515 17.8052 15.355L19.8802 12.545C19.9552 12.44 19.9952 12.315 19.9952 12.19C19.9952 11.61 19.2552 11.37 18.9102 11.835L16.8352 14.645H16.8402Z",
    fill: "#D0D7DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineCenter);
export default __webpack_public_path__ + "static/media/line-center.3af6cd54d8bd718d48f5d7f3c075b2d9.svg";
export { ForwardRef as ReactComponent };